<button
   mat-fab
   extended
   (click)="openDialog($event)"
   class="button"
>
    {{'checkPreviewSurvey' | translate}}
</button>

